import { Navigate } from 'react-router-dom';
import { useGlobal } from '../../context/GlobalContext';

export function NotFound() {
    const { userKey, isLoading } = useGlobal();

    if (isLoading) return null;

    return <Navigate to={userKey ? "/overview" : "/"} replace />;
}
